export default {"src":"/_next/static/media/Trauma-2.1cca1bbb.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};